import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = ({ language }) => {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'MapPin',
      title: { en: 'Verified Farms', zh: '认证农场' },
      description: { en: 'Real geospatial data from authentic African coffee farms', zh: '来自真实非洲咖啡农场的地理空间数据' }
    },
    {
      icon: 'FileCheck',
      title: { en: 'Quality Reports', zh: '质量报告' },
      description: { en: 'Downloadable test reports and certifications', zh: '可下载的测试报告和认证' }
    },
    {
      icon: 'TrendingUp',
      title: { en: 'Direct Trade', zh: '直接贸易' },
      description: { en: 'Connect directly with verified suppliers', zh: '直接与认证供应商联系' }
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary/10 via-accent/10 to-secondary/10 rounded-lg p-8 lg:p-12">
      <div className="max-w-4xl mx-auto text-center mb-8">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
          {language === 'en' ? 'Why Choose Africoffee?' : '为什么选择Africoffee？'}
        </h2>
        <p className="text-lg text-foreground/80">
          {language === 'en' ?'Your trusted partner for premium African green coffee beans with complete transparency' :'您值得信赖的优质非洲生咖啡豆合作伙伴，完全透明'}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {features?.map((feature, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border border-border shadow-card">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
              <Icon name={feature?.icon} size={24} color="var(--color-primary)" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
              {feature?.title?.[language]}
            </h3>
            <p className="text-sm text-muted-foreground">
              {feature?.description?.[language]}
            </p>
          </div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          variant="default"
          size="lg"
          onClick={() => navigate('/browse-beans')}
          iconName="Search"
          iconPosition="left"
        >
          {language === 'en' ? 'Browse All Beans' : '浏览所有咖啡豆'}
        </Button>
        <Button
          variant="outline"
          size="lg"
          onClick={() => navigate('/interactive-farm-map')}
          iconName="Map"
          iconPosition="left"
        >
          {language === 'en' ? 'Explore Farm Map' : '探索农场地图'}
        </Button>
      </div>
    </div>
  );
};

export default CTASection;